<template>
   <div>
       <button-gutter>
           <template v-if="![23, 127].includes(scope.row.type)">
           <el-button type="danger"
                      size="mini"
                      @click="$emit('publish', scope.row)"
                      v-if="scope.row.status === 0 ">发布
           </el-button>

           <task-copy-button :taskid="scope.row.taskid + ''"
                             class="button-gutter-item"
                             @search="onSearch">复制
           </task-copy-button>

           <router-link :to="'/task/update/'+scope.row.taskid"
                        v-if="scope.row.status === 0 || scope.row.status === 1"
           >
               <el-button type="primary"
                          size="mini">修改
               </el-button>
           </router-link>
           <task-delete-button :status="scope.row.status"
                               :taskid="scope.row.taskid + ''"
                               @search="onSearch">删除
           </task-delete-button>

           <router-link
                   :to="{path: '/task/preview-app/'+scope.row.taskid,query:{userid: '1'}}">
               <el-button type="success"
                          size="mini">预览任务
               </el-button>
           </router-link>
           </template>
          <router-link
              v-if="scope.row.type === 127"
              :to="{path: '/task/md/table/'+scope.row.taskid}">
               <el-button type="success"
                          size="mini">查看包含任务
               </el-button>
           </router-link>

           <router-link :to="{path: '/task/nearby-users/'+scope.row.taskid}"
                   v-if="scope.row.marketid !== 0">
               <el-button type="success"
                          size="mini">周边零工
               </el-button>
           </router-link>
       </button-gutter>
   </div>
</template>

<script>
    import TaskBatchPublishButton from '@/views/task/components/buttons/TaskBatchPublishButton'
    import TaskBatchDeleteButton from '@/views/task/components/buttons/TaskBatchDeleteButton'
    import TaskPublishOnSearchButton from '@/views/task/components/buttons/TaskPublishOnSearchButton'
    import TaskCopyButton from '@/views/task/components/buttons/TaskCopyButton'
    import TaskDeleteButton from '@/views/task/components/buttons/TaskDeleteButton'
    import table from '@core/mixins/table'

    export default {
      mixins: [table],
      components: {
        TaskCopyButton,
        TaskPublishOnSearchButton,
        TaskBatchPublishButton,
        TaskBatchDeleteButton,
        TaskDeleteButton,
      },
      props: {
        scope: Object,
      }
    }
</script>



// WEBPACK FOOTER //
// src/views/task/components/buttons/TaskOperationButtons.vue